import { memo, FC } from 'react';

interface IComponentProps {
  props?: any;
}

const GridFieldsEditor: FC<IComponentProps> = () => {
  return <p />;
};

export default memo(GridFieldsEditor);
